export default __webpack_public_path__ + "static/media/complementary--distance--g3.2d9b5876.png";